import { inputAdornmentClasses } from '@mui/material/InputAdornment';
export var createMuiInputAdornmentOverrides = function (_a) {
    var _b;
    var spacing = _a.spacing, tokens = _a.tokens;
    return {
        styleOverrides: {
            root: {
                color: tokens.color_fg_bold,
            },
            positionEnd: (_b = {
                    marginLeft: spacing(1.25)
                },
                _b["&.".concat(inputAdornmentClasses.sizeSmall)] = {
                    marginRight: -2,
                },
                _b),
        },
    };
};
